import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Heading, Paragraph } from '@digdir/designsystemet-react';
import type {
  ActionPlan,
  ActionPlanning,
} from '../../../api/workEnvironmentTypes';
import { Routes } from '../../../enums/Routes';
import { dayAndMonth } from '../surveyProcessView';
import process from '../WorkEnvironmentSurveyProcess.module.css';

type Props = {
  plan: ActionPlan;
  measurements: NonNullable<ActionPlanning['measurements']>;
};

/** The measurements the plan chose, and when the team gets the next one */
export const MeasurementCard = ({
  plan,
  measurements,
}: Props): ReactElement => {
  const { t, i18n } = useTranslation();
  const date = (value: string) => dayAndMonth(value, i18n.language);
  return (
    <section
      aria-labelledby="follow-up-measurement-heading"
      className={`${process.card} ${process.sideCard}`}
    >
      <Heading level={2} data-size="xs" id="follow-up-measurement-heading">
        {t('workEnvironmentFollowUp.measurement.title')}
      </Heading>
      {plan.measurePulse && (
        <>
          <Paragraph data-size="sm">
            {measurements.pulse
              ? t('workEnvironmentFollowUp.measurement.nextPulse', {
                  date: date(measurements.pulse),
                })
              : t('workEnvironmentFollowUp.measurement.noPulse')}
          </Paragraph>
          <Link to={Routes.DashboardCustomSurveys} className="ds-link">
            {t('workEnvironmentFollowUp.measurement.pulseLink')}
          </Link>
        </>
      )}
      {plan.measureSafety && (
        <>
          <Paragraph data-size="sm">
            {measurements.safety
              ? t('workEnvironmentFollowUp.measurement.nextSafety', {
                  date: date(measurements.safety),
                })
              : t('workEnvironmentFollowUp.measurement.noSafety')}
          </Paragraph>
          <Link to={Routes.DashboardPsychologicalSafety} className="ds-link">
            {t('workEnvironmentFollowUp.measurement.safetyLink')}
          </Link>
        </>
      )}
    </section>
  );
};
